module.exports = __webpack_public_path__ + "static/img/XREAL Air 2 Pro.da054408.png";